import { compose, withHandlers } from 'recompose';
import withToggle from '../../hoc/withToggle';
import RefundModalSplit from '../components/RefundModalSplit';

const RefundModalSplitContainer = compose(
  withToggle(),
  withHandlers({
    onMaxClick: props => () => props.refund(props.item),
  })
);

export default RefundModalSplitContainer(RefundModalSplit);
